<template>
  <div class="row">
    <div class="col-8 left-pane">
      <template v-if="question">
        <div class="row no-gutters">
          <div class="col-6 p-1">
            <div class="row" v-if="question.content">
              <span class="mj" v-html="question.content" />
            </div>
            <div class="row" v-if="question.contentImageData">
              <img
                class="content-image"
                v-bind:src="
                  'data:image/jpeg;base64,' + question.contentImageData
                "
              />
            </div>
            <div class="col-12 my-3">
              <h5>
                Answers
              </h5>
            </div>
            <div class="col-12" v-if="question.answers">
              <ul class="ans-lists">
                <template v-for="(a, i) in question.answers">
                  <li class="answer-style" :key="i">
                    <span>{{ listChar(i) + '. ' }}</span>
                    <span class="mj" v-html="a" />
                  </li>
                </template>
              </ul>
            </div>
            <div class="col-12 my-3" v-if="question.answerImagesData">
              <ul class="ans-lists">
                <template v-for="(a, i) in question.answerImagesData">
                  <li class="answer-style" :key="i">
                    <span>{{ listChar(i) }}</span>
                    <img
                      class="answer-image"
                      v-bind:src="'data:image/jpeg;base64,' + a"
                    />
                  </li>
                </template>
              </ul>
            </div>
          </div>
          <div class="col-6 p-1">
            <div class="col-12" v-if="refQuestion.content">
              <span class="mj" v-html="refQuestion.content" />
            </div>
            <div class="col-12" v-if="question.contentImageData">
              <img
                class="content-image"
                v-bind:src="
                  'data:image/jpeg;base64,' + question.contentImageData
                "
              />
            </div>
            <div class="col-12 my-3">
              <h5>
                Answers
              </h5>
            </div>
            <div class="col-12" v-if="refQuestion.answers">
              <ul class="ans-lists">
                <template v-for="(a, i) in refQuestion.answers">
                  <li class="answer-style" :key="i">
                    <span>{{ listChar(i) + '. ' }}</span>
                    <span class="mj" v-html="a" />
                  </li>
                </template>
              </ul>
            </div>
            <div class="col-12 my-3" v-if="question.answerImagesData">
              <ul class="ans-lists">
                <template v-for="(a, i) in question.answerImagesData">
                  <li class="answer-style" :key="i">
                    <span>{{ listChar(i) }}</span>
                    <img
                      class="answer-image"
                      v-bind:src="'data:image/jpeg;base64,' + a"
                    />
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="col-4 right-pane">
      <div class="col-12">
        <h4><span class="badge badge-primary">Fully check</span></h4>
      </div>
      <div class="col-12 check-step">
        <span class="badge badge-info">Step 1</span> Answer the question.
      </div>
      <div
        class="col-12"
        v-if="question && (question.answers || question.answerImages)"
      >
        <div
          :class="{
            'col-12': true,
            'my-2': true,
            invalid: !validate_input['user-ans']
          }"
        >
          Please select the correct answer.
        </div>
        <div class="col-12 m-2">
          <template v-for="(_, i) in 4">
            <div :key="i" class="form-check form-check-inline ml-2">
              <input
                class="form-check-input answer-options"
                type="radio"
                name="answerOptions"
                :id="'answer-' + i"
                :value="'' + (i + 1)"
                v-model="user_ans"
              />
              <label class="form-check-label" :for="'answer-' + i">
                {{ listChar(i) }}
              </label>
            </div>
          </template>
          <div class="form-check form-check-inline ml-2">
            <input
              class="form-check-input answer-options"
              type="radio"
              name="answerOptions"
              id="answer-none"
              :value="'101'"
              v-model="user_ans"
            />
            <label class="form-check-label" for="answer-none">
              Leave it blank
            </label>
          </div>
        </div>
      </div>
      <div class="col-12 check-step">
        <span class="badge badge-info">Step 2</span> Spot problems in the
        question and answers (if any).
      </div>
      <div class="col-12 m-3">
        <div class="form-check m-2">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="err_check[0].checked"
            @change="localEventHandler('click-no-problem-qa')"
          />
          <label class="form-check-label">
            {{ err_check[0].caption }}
          </label>
        </div>
        <div v-for="(c, i) in err_check" :key="c.code">
          <div v-if="i > 0 && i <= 2">
            <div class="form-check m-2">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="err_check[i].checked"
                @change="localEventHandler('click-problem-qa')"
              />
              <label class="form-check-label">
                {{ c.caption }}
              </label>
            </div>
            <div class="form-group m-3" v-if="c.checked == true">
              <textarea
                :class="{
                  'form-control': true,
                  'is-invalid': c.comment == ''
                }"
                rows="3"
                maxlength="1024"
                placeholder="Please specify"
                v-model="err_check[i].comment"
              />
            </div>
          </div>
        </div>
        <div class="form-check m-2">
          <input
            class="form-check-input"
            type="checkbox"
            id="qa-err-incorrect"
            v-model="qa_incorrect.checked"
            @change="
              localEventHandler('qa-incorrect-check') ||
                localEventHandler('click-problem-qa')
            "
          />
          <label class="form-check-label" for="qa-err-incorrect">
            The question is incorrect.
          </label>
        </div>
        <div v-if="qa_incorrect.checked">
          <div
            :class="{
              'ml-4': true,
              'my-1': true,
              invalid: !validate_input['qa-incorrect']
            }"
          >
            Please choose one of the following:
          </div>
          <div v-for="c in err_check.slice(3, 7)" :key="c.code">
            <div class="form-check ml-4 my-1">
              <input
                class="form-check-input"
                type="radio"
                name="qa-incorrect-options"
                :value="c.code"
                v-model="qa_incorrect.code"
              />
              <label class="form-check-label">
                {{ c.caption }}
              </label>
            </div>
          </div>
          <div class="form-group ml-4 my-1" v-if="qa_incorrect.checked == true">
            <textarea
              :class="{
                'form-control': true,
                'is-invalid': qa_incorrect.comment == ''
              }"
              rows="3"
              maxlength="1024"
              placeholder="Please specify"
              v-model="qa_incorrect.comment"
            />
          </div>
        </div>
        <div class="form-check m-2">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="err_check[7].checked"
            @change="localEventHandler('click-problem-qa')"
          />
          <label class="form-check-label" for="qa-err-other">
            Others.
          </label>
        </div>
        <div class="form-group ml-4" v-if="err_check[7].checked == true">
          <textarea
            :class="{
              'form-control': true,
              'is-invalid': err_check[7].comment == ''
            }"
            rows="3"
            maxlength="1024"
            placeholder="Please specify"
            v-model="err_check[7].comment"
          />
        </div>
        <small class="invalid" v-if="!validate_input['ans-spot-qa']">
          Please choose at least one of the above options.
        </small>
      </div>

      <div class="col-12 ml-2 mt-3">
        <button
          type="button"
          class="btn btn-outline-primary"
          :disabled="states.submitting"
          @click="localEventHandler('click-submit')"
        >
          Submit
        </button>
      </div>

      <div class="col-12 ml-2" v-if="!validate_input['no-empty-comment']">
        <small class="invalid">
          For each checked reponse, please enter your comment.
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import api_tester from '@/api/api_tester'
export default {
  props: {
    seqId: 0,
    question: { type: Object, default: _ => {} },
    refQuestion: { type: Object, default: _ => {} },
    eventHandler: { type: Function, default: (name, event) => {} }
  },
  data () {
    return {
      user_ans: 0,
      err_check: [],
      states: {
        submitting: false
      },
      validate_input: {
        'user-ans': true,
        'qa-incorrect': true,
        'no-empty-comment': true,
        'ans-spot-qa': true
      },
      qa_incorrect: { checked: false, code: '', comment: '' }
    }
  },
  created () {
    this.err_check = [
      {
        caption: 'No problem spotted in the questions and the answers.',
        code: null,
        checked: false
      },
      {
        caption:
          'The question and/or answers have typos, grammar or format issues.',
        code: 'qa_typo_grammar_format',
        checked: false,
        comment: ''
      },
      {
        caption: 'The question is ambiguous or misleading.',
        code: 'qa_ambiguous',
        checked: false,
        comment: ''
      },
      {
        caption: 'None of the answers is correct.',
        code: 'qa_no_correct_ans',
        tag: 'incorrect',
        checked: false,
        comment: ''
      },
      {
        caption: 'More than one of the answers are correct.',
        code: 'qa_two_correct_ans',
        tag: 'incorrect',
        checked: false,
        comment: ''
      },
      {
        caption: 'There are other possible answers.',
        code: 'qa_other_ans',
        tag: 'incorrect',
        checked: false,
        comment: ''
      },
      {
        caption: 'Other issues.',
        code: 'qa_incorrect_others',
        tag: 'incorrect',
        checked: false,
        comment: ''
      },
      { caption: 'Others.', checked: false, comment: '', code: 'qa_others' }
    ]
  },
  methods: {
    localEventHandler (name, event) {
      if (name == 'qa-incorrect-check') {
        this.qa_incorrect.code = ''
        this.qa_incorrect.comment = ''
      } else if (name == 'click-submit') {
        this.submit()
      } else if (name == 'click-no-problem-qa') {
        for (var i = 1; i <= 3; ++i) {
          this.err_check[i].checked = false
        }
      } else if (name == 'click-problem-qa') {
        this.err_check[0].checked = false
      }
    },
    listChar (num) {
      return String.fromCharCode(65 + num)
    },
    reset () {
      this.user_ans = 0
      for (var i = 0; i < this.err_check.length; ++i) {
        this.err_check[i].checked = false
        this.err_check[i].comment = ''
      }
      this.qa_incorrect.checked = false
      this.qa_incorrect.comment = ''
    },
    validate () {
      // validate answer
      this.validate_input['user-ans'] = this.user_ans != 0
      this.validate_input['qa-incorrect'] =
        this.qa_incorrect.checked == false || this.qa_incorrect.code != ''
      this.validate_input['no-empty-comment'] = true
      this.err_check.map(x => {
        if (x.comment == '' && x.checked == true && x.code != null) {
          this.validate_input['no-empty-comment'] = false
        }
      })
      this.validate_input['ans-spot-qa'] =
        this.err_check[0].checked ||
        this.err_check[1].checked ||
        this.err_check[2].checked ||
        this.qa_incorrect.checked ||
        this.err_check[7].checked
      return (
        this.validate_input['user-ans'] &&
        this.validate_input['qa-incorrect'] &&
        this.validate_input['no-empty-comment'] &&
        this.validate_input['ans-spot-qa']
      )
    },
    updateErrCheck () {
      if (this.qa_incorrect.checked) {
        this.err_check.map((x, i) => {
          if (x.code == this.qa_incorrect.code) {
            x.checked = true
            x.comment = this.qa_incorrect.comment
          } else if (x.tag == 'incorrect') {
            x.checked = false
          }
        })
      }
    },
    submit () {
      if (this.validate()) {
        this.states.submitting = true
        // do submit, then
        this.updateErrCheck()
        var report = this.err_check.filter(
          x => x.checked == true && x.code != null
        )
        Promise.all(
          [
            api_tester
              .save_answer(this.seqId, Number(this.user_ans))
              .then(res => {
                this.eventHandler('update-solution', {
                  solution: res.solution,
                  refSolution: res.refSolution
                })
                return res
              })
          ].concat(
            report.map(x =>
              api_tester.save_report(this.seqId, x.code, x.comment)
            )
          )
        ).then(q => {
          this.states.submitting = false
          var success = true
          q.map(x => {
            if (x.success != true) {
              success = false
            }
          })
          if (success == true) {
            this.eventHandler('submit-success')
          } else {
            this.eventHandler('submit-error')
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.left-pane-tab {
  max-height: 75vh;
  height: 75vh;
  overflow-x: hidden;
}
.right-pane {
  max-height: 80vh;
  height: 80vh;
  overflow-x: hidden;
}

.ans-lists {
  list-style-type: none;
  width: 100%;
  padding-inline-start: 10px !important;
}

.content-image {
  max-width: 350px;
  vertical-align: text-top;
}

.check-step {
  margin: 10px 10px;
  width: 100%;
  font-weight: bold;
  font-size: 20px;
}

.answer-style {
  padding: 10px 10px;
  margin: 5px 5px;
  font-size: 18px;
  border-radius: 23px;
  border: solid 1px #979797;
  display: inline-block;
}

.answer-image {
  max-width: 300px;
  vertical-align: text-top;
}

.answer-options {
  margin: 10px 5px !important;
  font-size: 18px;
}

.invalid {
  color: red;
}
</style>
